export enum HcpUpdateStatus {
  Available = "available",
  Downloaded = "downloaded",
}
